import { useCallback } from "react";

import {
  CertificationExpirationForm,
  ExpirationState,
} from "@/components/pages_logged_in/certifications/CertificationExpirationForm";
import { CharacterLimit } from "@/components/pages_logged_in/certifications/CharacterLimit";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";

export const nameMaxLength = 60;
export const descriptionMaxLength = 300;

export function CertificationForm({
  name,
  description,
  expiration,
  onNameChange,
  onDescriptionChange,
  onExpirationChange,
}: {
  name: string;
  description: string;
  expiration: ExpirationState;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onExpirationChange: (expiration: ExpirationState) => void;
}) {
  const handleNameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onNameChange(e.target.value);
    },
    [onNameChange],
  );
  const handleDescriptionChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onDescriptionChange(e.target.value);
    },
    [onDescriptionChange],
  );
  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-2">
        <div className="flex justify-between">
          <div className="text-base font-semibold">Title</div>
          <CharacterLimit value={name} max={nameMaxLength} />
        </div>
        <Input
          value={name}
          onChange={handleNameChange}
          placeholder="Certification Name"
          className={cn(
            name.length > nameMaxLength && "focus-visible:border-red-700",
          )}
        />
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex justify-between items-end">
          <div className="flex flex-col gap-4">
            <div className="text-base/4 font-semibold">
              Description (Optional)
            </div>
            <div className="text-sm text-muted-foreground">
              What competencies does this certification recognize?
            </div>
          </div>
          <CharacterLimit value={description} max={descriptionMaxLength} />
        </div>
        <Textarea
          value={description}
          onChange={handleDescriptionChange}
          placeholder="Add description"
          className={cn(
            description.length > descriptionMaxLength &&
              "focus-visible:border-red-700",
          )}
        />
      </div>
      <div className="flex flex-col gap-2">
        <div className="text-base font-semibold">Expiration</div>
        <CertificationExpirationForm
          expiration={expiration}
          onExpirationChange={onExpirationChange}
        />
      </div>
    </div>
  );
}
